export const UNAUTHORIZED = 401;
export const NOT_FOUND = 404;
export const SERVICE_UNAVAILABLE = 503;
export const TIMED_OUT = 504;
